// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

/** ChargeItem identifier system linking a ChargeItem to its Appointment id. */
export const APPOINTMENT_CHARGE_APPOINTMENT_SYSTEM =
  'http://polarissleep.com/identifier/appointment-charge-appointment';

/** Canonical ChargeItemDefinition for the patient no-show / late-cancellation fee. */
export const APPOINTMENT_MISSED_VISIT_FEE_DEFINITION_URL =
  'http://polarissleep.com/charge-item-definitions/no-show-fee';
export const APPOINTMENT_MISSED_VISIT_FEE_CODE = 'no-show-fee';
export const APPOINTMENT_MISSED_VISIT_FEE_AMOUNT_USD = 50;
export const APPOINTMENT_WAIVER_PROVENANCE_REASON_SYSTEM =
  'http://polarissleep.com/fhir/CodeSystem/appointment-fee-waiver-reason';

/** Encounter CPT codes that require an upfront patient payment before the appointment is confirmed. */
export const PRE_ENCOUNTER_CHARGEABLE_CPTS: ReadonlySet<string> = new Set(['99202', '99212', '99213']);

/** Canonical URL of the seeded ChargeItemDefinition for the given CPT code. */
export function appointmentChargeDefinitionUrl(cpt: string): string {
  return `http://polarissleep.com/charge-item-definitions/${cpt}`;
}

/** Extension URL stamped on Appointment when auto-cancelled by the unpaid-appointment cron. */
export const APPOINTMENT_CANCELLED_REASON_EXTENSION_URL =
  'http://polarissleep.com/fhir/StructureDefinition/appointment-cancelled-reason';

/** Value for APPOINTMENT_CANCELLED_REASON_EXTENSION_URL when cron auto-cancels an unpaid appointment. */
export const APPOINTMENT_CANCELLED_REASON_PAYMENT_NOT_RECEIVED = 'payment-not-received';
